import type { FC } from "react";
import { EarlierFinishViz } from "web_myplann/Goals/Components/ExtraContribution/EarlierFinishViz";
import { HigherTotalViz } from "web_myplann/Goals/Components/ExtraContribution/HigherTotalViz";
import type { ExtraContributionImpact } from "web_myplann/Goals/Types/ExtraContributionImpact";
import { ExtraContributionScenario } from "web_myplann/Goals/Types/ExtraContributionScenario";
import type { CurrencyEnum } from "web_myplann/Infrastructure/Api/Api";

type Props = {
	scenario: ExtraContributionScenario;
	impact: ExtraContributionImpact;
	savedLabel: string;
	currencyCode?: CurrencyEnum;
};

export const ScenarioViz: FC<Props> = ({
	scenario,
	impact,
	savedLabel,
	currencyCode,
}) =>
	scenario === ExtraContributionScenario.Earlier ? (
		<EarlierFinishViz impact={impact} savedLabel={savedLabel} />
	) : (
		<HigherTotalViz impact={impact} currencyCode={currencyCode} />
	);
